import PaperPlaneIcon from "./Icons/PaperPlaneIcon";
import React from "react";
const CheckoutHeader = () => (
  <div className="checkout-header">
    <h3>
      great choice!
    </h3>
    <div>
      We like your style.
    </div>
    <div className="delivery-desktop color-coral-2-bg">
      <span>
        <PaperPlaneIcon />
      </span>
      <span className="bold">
        ships in 1-2 business days
      </span>
    </div>
  </div>
);

export default CheckoutHeader;
